
module.exports = function ($rootScope, $q, Restangular, $http) {

    const CHATSERVER_BASE_URL = window.config.CHATSERVER_BASE_URL,
        CHATSERVER_JWT = window.config.CHATSERVER_JWT,
        INPUT_OPTIONS = require('./selfexclusion-setup'),
        _ = require('lodash');

    function SelfexclusionService() {
         this.feedbackURL = `${CHATSERVER_BASE_URL}/api/Zendesk/PostCreateTicket`;
        this._api = Restangular.one('selfexclusion');
        this.isFormSubmittedSuccessfully = false;
    }

    SelfexclusionService.prototype.getFieldId = function (key) {
        return INPUT_OPTIONS[key] && INPUT_OPTIONS[key].fieldId ? INPUT_OPTIONS[key].fieldId : undefined;
    };

    SelfexclusionService.prototype.submitForm = function (selected) {
        const ticketRequest = {
            appName: 'BWSUI',
            ticket: {
                subject: 'Hub Contact Us',
                brand_id: this.getFieldId('brand_id'),
                ticket_form_id: this.getFieldId('ticket_form_id'),
                custom_fields: []
            }
        };
        ticketRequest.ticket.comment = {
            body: 'Self Exclusion Ticket'
        };
        ticketRequest.ticket.requester = {
            name: `${selected.FirstName} ${selected.LastName}`,
            email: selected.EmailAddress
        };
        ticketRequest.ticket.custom_fields.push({
            id: this.getFieldId('self_exclusion_ticket'),
            value: 'self_exclusion'
        });
        //other fields
        _.mapKeys(selected, (selectedValue, key) => {
            if (selectedValue && this.getFieldId(key)) {
                const id = this.getFieldId(key);
                let value = selectedValue.value ? selectedValue.value : selectedValue;
                if (value.label && value.label === '-') {
                    value = null;
                }
                if (value) {
                    ticketRequest.ticket.custom_fields.push({
                        id,
                        value
                    });
                }
            }
        });

        return $http.post(this.feedbackURL, ticketRequest, { headers: { 'Ocp-Apim-Subscription-Key': CHATSERVER_JWT } });
    };


    SelfexclusionService.prototype.save = function (args) {
        console.log('SelfexclusionService-->save called');
        return this._api.doPOST(args);
    };

    SelfexclusionService.prototype.registrationStart = function () {
        // check if this page was already visited (localStorage)
        //const isRegistrationAlreadyVisited = this.AtmLocalService.getState('shop.authentication.signup') ? false : true;

        // send an analytics event when the user start a form registration
        //this.atm.push(isRegistrationAlreadyVisited, atmRegistrationEvents.start);
    };

    SelfexclusionService.prototype.registrationAbandoned = function () {
        // check if the form was submitted successfully
        //if (!this.isFormSubmittedSuccessfully) {
        //    // if not then trigger an analytics registerAbandoned event
        //    this.atm.push(lastDirtyField, atmRegistrationEvents.abandoned);
        //}
    };

    return new SelfexclusionService();
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/selfexclusion/selfexclusion-service.js
 **/